export default "__VITE_ASSET__Cch9QGnU__"